import { render, staticRenderFns } from "./GoodsTabsCustomTabs.vue?vue&type=template&id=73dbdfb4&scoped=true"
import script from "./GoodsTabsCustomTabs.vue?vue&type=script&lang=js"
export * from "./GoodsTabsCustomTabs.vue?vue&type=script&lang=js"
import style0 from "./GoodsTabsCustomTabs.vue?vue&type=style&index=0&id=73dbdfb4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dbdfb4",
  null
  
)

export default component.exports